import {apiUserLink} from "@pg-mono/rp-api-routes";
import {IKeyVariable, IVariable} from "@pg-rp/homematch-tinder";

import {rpApi} from "../../app/api/rp_api";

/** The subset of `/user-api/proxy/variables/` dictionaries the details card renders. */
export interface IHomematchVariables {
    offer_facilities: IVariable[];
    offer_parking_place_type: IKeyVariable[];
    offer_standard_description_type: IKeyVariable[];
    property_quarters: IKeyVariable[];
}

export const getHomematchVariablesApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomematchVariables: builder.query<IHomematchVariables, void>({
            query: () => ({
                url: apiUserLink.homeMatch.variables
            })
        })
    }),
    overrideExisting: false
});

export const {useGetHomematchVariablesQuery} = getHomematchVariablesApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";
import {IKeyVariable, IVariable} from "@pg-rp/homematch-tinder";

import {rpApi} from "../../app/api/rp_api";

/** The subset of `/user-api/proxy/variables/` dictionaries the details card renders. */
export interface IHomematchVariables {
    offer_facilities: IVariable[];
    offer_parking_place_type: IKeyVariable[];
    offer_standard_description_type: IKeyVariable[];
    property_quarters: IKeyVariable[];
}

export const getHomematchVariablesApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomematchVariables: builder.query<IHomematchVariables, void>({
            query: () => ({
                url: apiUserLink.homeMatch.variables
            })
        })
    }),
    overrideExisting: false
});

export const {useGetHomematchVariablesQuery} = getHomematchVariablesApi;
